import { ArrowUpRight, CheckCircle2 } from 'lucide-react';
import { content, Chapter, Reveal, Icon } from './Shared';

export const CollegeSupport = ({ onEnquire }) => {
  const support = content.collegeSupport;
  return <section id="colleges" className="section college-support-section" data-testid="college-support-section">
    <div className="wrap">
      <Chapter id="colleges" intro={content.collegeSupportIntro}/>
      <div className="college-support-layout">
        <Reveal className="college-pathway" data-testid="college-pathway">
          <span className="eyebrow">ESTABLISHMENT PATHWAY</span>
          <h3 data-testid="college-pathway-heading">{support.overviewTitle}</h3>
          <p data-testid="college-pathway-description">{support.overview}</p>
          <ol data-testid="college-pathway-stages">{support.stages.map((stage, index) => <li key={stage} data-testid={`college-stage-${index}`}><span>0{index + 1}</span>{stage}</li>)}</ol>
        </Reveal>
        <div className="college-card-grid">{support.colleges.map((college, index) => <Reveal key={college.title} delay={index * .08} className="college-card-wrap">
          <article className="college-card" data-testid={`college-card-${index}`}>
            <div className="college-card-top"><span><Icon name={college.icon} size={31}/></span><small>0{index + 1}</small></div>
            <h3 data-testid={`college-title-${index}`}>{college.title}</h3>
            <p data-testid={`college-summary-${index}`}>{college.summary}</p>
            <ul data-testid={`college-support-list-${index}`}>{college.support.map(item => <li key={item}><CheckCircle2 size={17}/>{item}</li>)}</ul>
            <a href="#contact" className="college-enquire" onClick={() => onEnquire?.(college.service, `Hello QualiNova, I would like to discuss complete establishment, expansion and accreditation support for a ${college.title.replace(/s$/, '')}.`)} data-testid={`college-enquire-${index}`}>Discuss this pathway <ArrowUpRight size={17}/></a>
          </article>
        </Reveal>)}</div>
      </div>
      <Reveal className="college-note" data-testid="college-support-note"><Icon name="ShieldCheck" size={22}/><p>{support.note}</p></Reveal>
    </div>
  </section>;
};
